// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapperBackgroundSeating {\n  position: relative;\n}\n.wrapperBackgroundSeating .colorEditButton {\n  width: 98px;\n}\n.wrapperBackgroundSeating .progressContainerTemplate {\n  position: absolute;\n  bottom: 120px;\n  left: 23px;\n  z-index: 3;\n}", ""]);
// Exports
module.exports = exports;
